import download from 'downloadjs';
import API, { defaultHeaders, IRI } from '@/api';

const fetchExport = payload => {
  const headers = Object.assign({}, defaultHeaders);
  headers.Authorization = `Bearer ${sessionStorage.getItem('token')}`;

  return fetch(`${API}${IRI.exam}export/${payload}`, {headers})
    .then(res => {
      if (res.status !== 200) {
        throw Error('Invalid download status');
      }

      return res.blob();
    })
    .then(blob => download(blob, `exam-stats.csv`, 'text/csv'))
    .catch(e => console.error(e))
  ;
};

export default fetchExport;
